module.exports = __webpack_public_path__ + "media/images/front/top/surgeons_learning-3433a5394b880e55f3a8a4fa0c9dbc9d.jpg";